// image-processing-loader
var previousRequest = require("!!../../../../../../node_modules/fox-file-loader/index.js!../../../../../../node_modules/file-loader/index.js?name=[path][name].[ext]!./bg_body.jpg");
var dir = previousRequest.replace("bg_body.jpg", "")
module.exports = require("!../../../../../../node_modules/fox-image-optimize-plugin/router.js")({
	dir: dir,
	base: "bg_body.jpg",
	name: "bg_body",
	ext: ".jpg",
	query: ""
}, previousRequest);


//////////////////
// WEBPACK FOOTER
// ./images/bg/bg_body.jpg
// module id = 992
// module chunks = 4